import React from "react";
import { cn } from "@/lib/utils";

/**
 * Songwriter Square logo lockup.
 *  variant = "mark"   -> just the square logo image
 *  variant = "inline" -> logo + "SONGWRITER SQUARE" wordmark to the right
 */
export function Logo({ variant = "mark", size = 40, className = "", "data-testid": dataTestId }) {
  const px = typeof size === "number" ? `${size}px` : size;
  if (variant === "inline") {
    return (
      <div
        className={cn("flex items-center gap-3", className)}
        data-testid={dataTestId || "brand-logo-inline"}
      >
        <img
          src="/logo.png"
          alt="Songwriter Square"
          width={40}
          height={40}
          style={{ width: px, height: px }}
          className="object-contain"
        />
        <div className="leading-tight">
          <div className="font-display uppercase text-[15px] text-gold tracking-[0.22em]">
            Songwriter
          </div>
          <div className="font-display uppercase text-[15px] text-white tracking-[0.22em]">
            Square
          </div>
        </div>
      </div>
    );
  }
  return (
    <img
      src="/logo.png"
      alt="Songwriter Square"
      width={size}
      height={size}
      style={{ width: px, height: px }}
      className={cn("object-contain select-none", className)}
      data-testid={dataTestId || "brand-logo-mark"}
      draggable={false}
    />
  );
}

export default Logo;
